import React from 'react';
import { REDUCER_NAME } from './reducer';
import { connect } from 'react-redux';
import Const from './Const';
import Table from '../../common/table/Table';
import './FADividendAnalysis.scss';
import { withComponentId } from './../../common/ComponentIdContext';
import { compose } from 'redux';
import { SimpleTooltip } from './../../common/tooltip';
import { formatTextFloat } from './../../helpers/Text';
import { I18n } from 'react-redux-i18n';

class FADividendAnalysisTable extends React.Component {
  getDataFromRedux = state => {
    const { componentId } = this.props;

    return state[REDUCER_NAME].listMultiComponent[componentId]
      .dataDividendTableByYear;
  };

  getSchema = () => {
    const currentYear = new Date().getFullYear();

    const getStyleCurrentYear = item => {
      return item && item.year === currentYear
        ? 'text-right pl-10 pr-10 isBlue'
        : 'text-right pl-10 pr-10';
    };

    return Object.keys(Const.listColumn).map(item => {
      const key = Const.listColumn[item];
      const title = `cashDividend.cashTable.${item}`;
      const result = {
        key,
        title,
        disableSort: true,
        thStyle: { textAlign: 'right' },
        tdStyle: { 'padding-left': 0, 'padding-right': 0 },
      };

      if (key === Const.listColumn.year) {
        return {
          ...result,
          title: '',
          render: text => <div className="text-right pl-10 pr-10">{text}</div>,
        };
      }

      if (key === Const.listColumn.jan) {
        return {
          ...result,
          ...this.renderItem(1),
        };
      }

      if (key === Const.listColumn.feb) {
        return {
          ...result,
          ...this.renderItem(2),
        };
      }

      if (key === Const.listColumn.mar) {
        return {
          ...result,
          ...this.renderItem(3),
        };
      }

      if (key === Const.listColumn.apr) {
        return {
          ...result,
          ...this.renderItem(4),
        };
      }

      if (key === Const.listColumn.may) {
        return {
          ...result,
          ...this.renderItem(5),
        };
      }

      if (key === Const.listColumn.jun) {
        return {
          ...result,
          ...this.renderItem(6),
        };
      }

      if (key === Const.listColumn.jul) {
        return {
          ...result,
          ...this.renderItem(7),
        };
      }

      if (key === Const.listColumn.aug) {
        return {
          ...result,
          ...this.renderItem(8),
        };
      }

      if (key === Const.listColumn.sep) {
        return {
          ...result,
          ...this.renderItem(9),
        };
      }

      if (key === Const.listColumn.oct) {
        return {
          ...result,
          ...this.renderItem(10),
        };
      }

      if (key === Const.listColumn.nov) {
        return {
          ...result,
          ...this.renderItem(11),
        };
      }

      if (key === Const.listColumn.dec) {
        return {
          ...result,
          ...this.renderItem(12),
        };
      }

      if (key === Const.listColumn.total) {
        return {
          ...result,
          render: (text, item) => (
            <>
              {item.year === currentYear && (
                <div className="tooltip-cell-table">
                  <SimpleTooltip
                    message={'cashDividend.estimatedNumber'}
                    position={'top'}
                    isI18n={true}
                  >
                    <div className={getStyleCurrentYear(item)}>
                      {formatTextFloat(text, 0)}
                    </div>
                  </SimpleTooltip>
                </div>
              )}
              {item.year !== currentYear && (
                <div className={getStyleCurrentYear(item)}>
                  {formatTextFloat(text, 0)}
                </div>
              )}
            </>
          ),
        };
      }

      if (key === Const.listColumn.yield) {
        return {
          ...result,
          render: text => {
            let result = '';
            if (text) {
              result = text === '--' ? text : text + '%';
            }
            return <div className="text-right pl-10 pr-10">{result}</div>;
          },
        };
      }

      return result;
    });
  };

  renderItem = index => ({
    render: (text, item) => {
      const getStyle = item => {
        return item && item.isRed
          ? 'text-center pl-10 pr-10 isRed'
          : 'text-center pl-10 pr-10 ';
      };

      if (!item[index]) {
        return '';
      }

      if (item[index].isRed) {
        return (
          <div className="tooltip-cell-table">
            <SimpleTooltip
              message={'cashDividend.expectedNumber'}
              position={'top'}
              isI18n={true}
            >
              <div className={getStyle(item[index])}>
                {formatTextFloat(item[index].total, 0)}
              </div>
            </SimpleTooltip>
          </div>
        );
      }

      return (
        <div className="tooltip-month">
          <div
            style={{
              top: `-${16 * item[index].items.length}px`,
            }}
            className="tooltip-content multiple-line"
          >
            {item[index].items.map(({ valuePerShare, dividendYear }, index) => (
              <div key={index}>
                {I18n.t('cashDividend.cellTooltip', {
                  value: formatTextFloat(valuePerShare, 0),
                  year: dividendYear,
                })}
              </div>
            ))}
          </div>
          <div className={getStyle(item[index])}>
            {formatTextFloat(item[index].total, 0)}
          </div>
        </div>
      );
    },
  });

  render() {
    const { ids = [] } = this.props;

    return (
      <div className="tab-pane active d-flex flex-column flex-fill h-auto">
        <Table
          stickyFirstColumn={false}
          resizable={true}
          columnDraggable={false}
          rowDraggable={false}
          getDataFromRedux={this.getDataFromRedux}
          ids={ids}
          schema={this.getSchema()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    componentId,
    ids:
      state[REDUCER_NAME].listMultiComponent[componentId].listDataDividendTable,
    locale: state.i18n.locale,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(FADividendAnalysisTable);
